import { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function TextSummarize() {
    const [summary, setSummary] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSummarize = async () => {
        const text = document.getElementById("paragraph").value;
        if (!text.trim()) {
            alert("Please enter some text to summarize.");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch("https://ai-feats.nugenesisou.com/summarize", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ text })
            });
            
            if (!response.ok) {
                throw new Error("Failed to summarize the text.");
            }

            const data = await response.json();
            setSummary(data.summary || "No summary generated.");
        } catch (error) {
            console.error("Error summarizing text:", error);
            setSummary("Error summarizing text. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Text Summarize</span>
                    </div>
                </section>

                <section class="security-hero">
                    <div class="content">
                        <div class="pad texts">
                            <h1><b>Free </b> AI Text Summarizer</h1>
                            <div class="subtitle">By NuGenesis</div>
                            <div class="text">Summarizer can condense articles, reports, or documents down to the key points instantly. Our AI uses natural language processing to locate critical information while maintaining the original context.</div>
                            <div class="text">Enter or paste your text and press "Summarize."</div>
                        </div>
                    </div>
                </section>

                <section class="pad security-hero">
                    <div class="content">
                        <div class="text-sum-container">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mt-3">
                                        <button class="paste-btn">📋 Paste Text</button>
                                    </div>
                                    <textarea class="form-control text-area not-focus" rows="15" id="paragraph"></textarea>
                                    <div class="mt-2">
                                        <a href="#" class="text-decoration-none">📂 Upload Doc</a>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <button class="summary-btn" id="sumarize-btn" onClick={handleSummarize}>
                                        {loading ? "Loading..." : "Summarize"}
                                    </button>
                                </div>

                                <div class="col-md-6">
                                    <div class="text-area" id="sumarize-txt">{summary}</div>
                                    <p class="mt-2">{summary ? `${summary.split(" ").length} words` : "0 words"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
